interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'left',
  tone = 'light',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`${isCenter ? 'text-center mx-auto max-w-2xl' : 'text-left max-w-2xl'}`}>
      {eyebrow ? (
        <span
          className={`inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase ${
            tone === 'light' ? 'text-primary-600' : 'text-accent-400'
          }`}
        >
          <span className="w-6 h-px bg-current inline-block" />
          {eyebrow}
        </span>
      ) : null}
      <h2
        className={`font-heading mt-3 text-2xl md:text-4xl font-bold leading-snug ${
          tone === 'light' ? 'text-foreground-950' : 'text-background-50'
        }`}
      >
        {title}
      </h2>
      {desc ? (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            tone === 'light' ? 'text-foreground-600' : 'text-background-200'
          }`}
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}